import { render, staticRenderFns } from "./btn-light.mpx?vue&type=template&id=62b20258&isComponent&outputPath=components%2Fbtn-light4a3b28eb%2Findex"
import script from "./btn-light.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-light4a3b28eb%2Findex"
export * from "./btn-light.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-light4a3b28eb%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports